let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("bzc8Q")).then(() => parcelRequire('al4VD'));